import { Stack } from '@mui/material';

import { Stars01Icon } from '@/components/icons/Stars01Icon';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { COLORS } from '@/styles/tokens/colors';

interface AIAssistBadgeProps {
  label?: string;
}

export function AIAssistBadge({ label = 'AI-powered' }: AIAssistBadgeProps) {
  return (
    <Badge
      variant={BadgeVariants.Success}
      display={
        <Stack display="inline-block" direction="row">
          <>{label}</>
          <Stars01Icon
            sx={{ position: 'relative', top: 2, ml: 0.5 }}
            size={12}
            color={COLORS.TEAL[700]}
          />
        </Stack>
      }
    />
  );
}
